import { connect } from 'react-redux';
import { IGetVillageListResponseSchema } from '../../../../node/repositories/countryside-search/entities/entities/GetVillageListResponseSchema';
import { IApplicationState, TTypedThunkDispatch } from '../../../types/store';

import { RoadsHeader } from '.';
import { IRoads } from '../../../store/roads';
import { changePopupRoadDistance, changeSubroads, filterPopupRoads } from '../../../store/roads/actions';
import { commutePick } from '../../../utils/commutePick';

export interface IRoadsHeaderProps {
  roadData: IGetVillageListResponseSchema['roadData'];
  roads: IRoads;
}

export interface IRoadsHeaderDispatchProps {
  filterRoads(text: string, roadDistance?: number, trackNotFound?: boolean): void;
  onChangePopupRoadDistance(value: number): void;
  onSelectRoad(value: number): void;
}

export type TRoadsHeaderProps = IRoadsHeaderProps & IRoadsHeaderDispatchProps;

export function mapStateToProps(state: IApplicationState): IRoadsHeaderProps {
  const {
    roads,
    villageList: { roadData },
  } = state;

  return {
    roadData: roadData ? commutePick(roadData, roads.currentRoads) : undefined,
    roads,
  };
}

export function mapDispatchToProps(dispatch: TTypedThunkDispatch): IRoadsHeaderDispatchProps {
  return {
    filterRoads: (text, roadDistance, trackNotFound) => dispatch(filterPopupRoads(text, roadDistance, trackNotFound)),
    onChangePopupRoadDistance: value => dispatch(changePopupRoadDistance(value)),
    onSelectRoad: value => dispatch(changeSubroads([value], true)),
  };
}

export const RoadsHeaderContainer = connect<IRoadsHeaderProps, IRoadsHeaderDispatchProps>(
  mapStateToProps,
  mapDispatchToProps,
)(RoadsHeader);
